import { styles } from './template.scss';
import { styles as commonStyles } from '../../../assets/common.scss';
import { styles as helpersStyles } from '../../../assets/text-helpers.scss';
import { styles as chartStyles } from './template-chart.scss';
import { ButtonColor } from '../../../ui/gzIconButton/types';
import { FontSizes, FontWeights } from '../../../types/common/types';

export const templateRiskIncidentPanel = document.createElement('template');

export const templateNoDataAvailableChart = document.createElement('template');

export const templateErrorLoadingChart = document.createElement('template');

templateRiskIncidentPanel.innerHTML = `
  <style>${commonStyles}</style>
  <style>${styles}</style>
  <style>${helpersStyles}</style>
  <div class="wrapper">
    <div id="titles">
      <gz-title fontSize="16" fontWeight="500" id="associated-risks-title" class="text-uppercase" ></gz-title>
      <gz-title fontSize="11" fontWeight="600" id="subtitle-risks" class="text-uppercase"></gz-title>
    </div>
    <div id="risks-incident-chart">
      <gz-general-donut-chart></gz-general-donut-chart>
    </div>
    <gz-button id='view-all-risks-button' color="primary" type="quiet"  buttonheight="small"
                  buttonfontsize="small"></gz-button>
    <div id="incident-risks-sections">
      <gz-risk-incident-section id="root-risks-section"></gz-risk-incident-section>
      <gz-risk-incident-section id="era-risks-section"></gz-risk-incident-section>
      <gz-risk-incident-section id="cloud-security-risks-section"></gz-risk-incident-section>
    </div>
    <div id="viewRisks">
    </div>
  </div>
`;

templateNoDataAvailableChart.innerHTML = `
    <style>${chartStyles}</style>
    <div class="status-message-chart" style="width: 70%">
        <gz-icon size="20" name='ds-icon-notification_warning' color="${ButtonColor.WARNING}">
        </gz-icon>
        <div class="status-message-div">
             <gz-text fontSize="${FontSizes.PARAGRAPH_12}"
                fontWeight="${FontWeights.BOLD}"class="no-data-text">
             </gz-text>
        </div>
    </div>
`;

templateErrorLoadingChart.innerHTML = `
    <style>${chartStyles}</style>
        <div class="status-message-chart">
            <gz-icon size="20" name='ds-icon-notification_negative' color="${ButtonColor.NEGATIVE}">
            </gz-icon>
            <div class="status-message-div">
                    <gz-text fontSize="${FontSizes.PARAGRAPH_12}"
                        fontWeight="${FontWeights.BOLD}" class="error-text">
                    </gz-text>
            </div>
        </div>
`;
